import { Button, Typography } from '@breetometer/components';
import slackLogo from 'BreetAssets/images/slack.png';
import { closeModal, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

// Opens Slack so the user can navigate to their dedicated support channel
const SLACK_URL = 'https://slack.com';

export const DialogContactSupport = () => {
	const dispatch = useAppDispatch();

	const handleSlack = useCallback(() => {
		window.open(SLACK_URL, '_blank', 'noopener,noreferrer');
		dispatch(closeModal('contactSupport'));
	}, [dispatch]);

	return (
		<div className='dialog_contactsupport'>
			<div className='dialog_contactsupport_icon'>
				<img
					src={slackLogo}
					alt='Slack'
					className='dialog_contactsupport_icon_img'
				/>
			</div>

			<div className='dialog_contactsupport_body'>
				<Typography
					as='h2'
					className='dialog_contactsupport_title'
				>
					Your support group is on Slack
				</Typography>

				<Typography
					as='p'
					className='dialog_contactsupport_subtitle'
				>
					You have a dedicated Slack channel with our support team for issues and account assistance. Head there anytime you need
					help or updates.
				</Typography>
			</div>

			<Button
				variant='native'
				className='dialog_contactsupport_cta'
				onClick={handleSlack}
				leadingIcon={
					<img
						src={slackLogo}
						alt='Slack'
						className='dialog_contactsupport_cta_img'
					/>
				}
			>
				Go to Slack
			</Button>
		</div>
	);
};

export default DialogContactSupport;
